import { render, staticRenderFns } from "./SettingsMargin.vue?vue&type=template&id=d407d2e0&"
import script from "./SettingsMargin.vue?vue&type=script&lang=js&"
export * from "./SettingsMargin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports